/*
  data[gender]: {
    id: null,
    name: null,
    price: null,
    discount: null,
    media: [],
    timeLeft: null,
    startDate: null,
    products: [],
  }
 */
export const initialState = {
  isFetched: false,
  isExpired: false,
  isTwoFlashSalesAvailable: false,
  timeLeft: null,
  startDate: null,
  data: {
    female: null,
    male: null,
    unisex: null,
  },
}


export const set = (state, payload /* item */) => ({
  ...initialState,
  ...payload,
  isFetched: true,
})

export const setTimeLeft = (state, payload /* timeLeft */) => ({
  ...state,
  timeLeft: payload,
})

export const setExpired = (state, payload) => ({
  ...state,
  isExpired: payload,
})

export const setIsFetched = (state, payload /* isFetched */) => ({
  ...state,
  isFetched: payload,
})
